import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

export const Drivetrain = withFacetContext(
    FacetName.drivetrain,
    withFilterContext(FilterName.drivetrain, SearchFiltersCheckboxes, {
        title: 'Drivetrain',
    })
)
